<template>
  <div class="dialog-scroll">
    <div class="viewable-area-style">
      <el-dialog
        class="search-popup"
        :show-close="false"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose">

        <div class="header-style">
          <div class="title-style">
            Outlookリソースを追加
          </div>
          <div style="display: flex;">
            <SpSmartButton class="cancel-button click-item" @click="cancel">
              キャンセル
            </SpSmartButton>
            <narrow-down
             @click="OutlookMeetingRoomCreate"
            :class="{ disabled: relatedList.length === 0  }"
             >
              登録
            </narrow-down>
          </div>
        </div>
        <div class="flow">
          <div>
            対象のエリアを選択
          </div>
          <div>
            <img class="rightArrow" src="@/assets/icon/rightArrow.svg"  alt="">
          </div>
          <div style="color: #529AA4;">
            連携するリソースを選択
          </div>
          <div>
            <img class="rightArrow" src="@/assets/icon/rightArrow.svg"  alt="">
          </div>
          <div>
            完了
          </div>
        </div>
        <div class="areaInfo">
          <span style="font-weight: 700;">
            {{ areaInfo.areaName }}
            （共有エリア）
          </span>
          <span>に連携するリソースを選択してください</span>
        </div>

        <div class="transfer-box">
          <div class="transfer">
            <div class="transfer-header">
              <span>連携するリソースを選択</span>
              <cancel-narrow-down class="link-primary margin-left-8" @click="toggleSelectAll">
                すべて選択
              </cancel-narrow-down>
            </div>
            <div class="transfer-search">
              <el-input
                maxlength="50"
                class="fm-input"
                v-model="query.meetingName"
                placeholder="施設名"
                @input="handleSearchChange" >
              </el-input>
            </div>
            <div id="search-result" class="transfer-body">
              <el-checkbox-group v-model="checkedResources">
                <div class="transfer-item" v-for="item in resourceList" :key="item.resourceID">
                  <el-checkbox :label="item" :disabled="item.inRelated">{{item.resourceName}}</el-checkbox>
                  <img class="rightArrow" src="@/assets/icon/icon_arrow.svg" :class="{ disabled: item.inRelated }" alt="" @click="addOneResources(item)">
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="transfer-button">
            <div
              class="transfer-btn"
              :class="{ disabled: checkedResources.length === 0 }"
              style="margin-bottom: 24px;"
              @click="handleAdd"
            >
              <img src="@/assets/icon/transfer-add.svg"  alt="">
              <div class="transfer-add">追加</div>
            </div>
            <div
              class="transfer-btn"
              :class="{ disabled: relatedCheckedResources.length === 0  }"
              @click="handleDelete"
            >
              <img src="@/assets/icon/transfer-delete.svg"  alt="">
              <div>削除</div>
            </div>
          </div>
          <div class="transfer">
            <div class="transfer-header">
              <span>施設の登録</span>
              <cancel-narrow-down class="link-primary margin-left-8" @click="handleCheckAllChange">
                すべて選択
              </cancel-narrow-down>
            </div>
            <div class="transfer-search">
              <el-input
                maxlength="50"
                class="fm-input"
                v-model="query.relatedMeetingName"
                placeholder="施設名"
                @input="handleRelatedSearchChange" >
              </el-input>
            </div>
            <div class="transfer-body">
              <el-checkbox-group v-model="relatedCheckedResources" v-show="relatedList || relatedList.length > 0">
                <div class="transfer-item" v-for="item in getFilteredRelatedList()" :key="item.resourceID">
                  <el-checkbox :label="item">{{item.resourceName}}</el-checkbox>
                  <img class="rightArrow" src="@/assets/icon/icon_delete.svg"  alt="" @click="deleteOneResources(item)">
                </div>
              </el-checkbox-group>
              <div class="noRelated" v-show="!relatedList || relatedList.length === 0">
                連携するリソースを選択してください
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <loading-dialog :dialogVisible="showLoading" />
    </div>

  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import LoadingDialog from "@/components/common/loading/LoadingDialog"

export default {
  components: {
    SpSmartButton,
    cancelNarrowDown,
    LoadingDialog: LoadingDialog,
    narrowDown
  },
  props: {
    visible: Boolean,
    orgIdParam: String,
    areaInfo: Object
  },
  data: function () {
    return {
      showLoading: false,
      debounceTimer: null,
      requestSeq: 0,
      orgId: null,
      dialogVisible: this.visible,
      resourceList: [],
      relatedList: [],
      originalRelatedList:[],
      checkedResources: [],
      relatedCheckedResources: [],
      query: {
        meetingName: null,
        relatedMeetingName: null
      }
    };
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer)
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if(this.orgIdParam !== undefined && this.orgIdParam !== null) {
        this.orgId = this.orgIdParam;
      }
      if (val) {
        this.loadData();
      }
    },

  },
  methods: {
    // getFilteredResourceList() {
    //   const keyword = this.query.meetingName?.trim().toLowerCase();

    //   if (!keyword) {
    //     return this.resourceList;
    //   }

    //   return this.resourceList.filter(item =>
    //     item.resourceName &&
    //     item.resourceName.toLowerCase().includes(keyword)
    //   );
    // },
    handleSearchChange() {
      clearTimeout(this.debounceTimer)

      this.debounceTimer = setTimeout(() => {
        this.checkedResources = []
        this.resourceList = []
        this.loadData()
      }, 500)
    },
    getFilteredRelatedList() {
      const keyword = this.query.relatedMeetingName?.trim().toLowerCase();

      if (!keyword) {
        return this.relatedList;
      }

      return this.relatedList.filter(item =>
        item.resourceName &&
        item.resourceName.toLowerCase().includes(keyword)
      );
    },
    handleRelatedSearchChange() {
      this.relatedCheckedResources = [];
    },
    loadData(){
      this.showLoading = true
      const requestSeq = ++this.requestSeq
      const requestKeyword = this.query.meetingName
      SystemManageApi.OutlookMeetingResourceGet({
        resourceName: requestKeyword,
        orgID: this.orgId,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if (requestSeq !== this.requestSeq || requestKeyword !== this.query.meetingName) {
          return
        }
        this.resourceList = []
        if (data.body.resourceInfo.length > 0) {
          const processedList = data.body.resourceInfo.map(item => {
            return {
              ...item,
              capacity: item.capacity > 21 ? 21 : item.capacity
            };
          });

          this.resourceList.push(...processedList);
        }


        // this.relatedList = []
        this.originalRelatedList = []
        if (data.body.resourceRelatedInfo.length > 0) {
          // this.relatedList.push(...data.body.resourceRelatedInfo);
          this.originalRelatedList.push(...data.body.resourceRelatedInfo);
        }

        this.syncRelatedFlag();
      }).finally(() => {
        if (requestSeq === this.requestSeq) {
          this.showLoading = false;
        }
      });
    },
    syncRelatedFlag() {
      const relatedIdSet = new Set([
        ...this.relatedList.map(item => item.resourceID),
        ...this.originalRelatedList.map(item => item.resourceID)
      ]);

      this.resourceList = this.resourceList.map(item => ({
        ...item,
        inRelated: relatedIdSet.has(item.resourceID)
      }));
    },

    toggleSelectAll() {
      const selectableList = this.resourceList.filter(
        item => !item.inRelated
      );

      if (selectableList.length === 0) {
        return;
      }

      const isAllSelected = this.checkedResources.length === selectableList.length;

      if (isAllSelected) {
        this.checkedResources = [];
      } else {
        this.checkedResources = [...selectableList];
      }
    },
    handleCheckAllChange(){
      const selectableList = this.getFilteredRelatedList();

      if (selectableList.length === 0) {
        return;
      }

      const isAllSelected = this.relatedCheckedResources.length === selectableList.length;

      if (isAllSelected) {
        this.relatedCheckedResources = [];
      } else {
        this.relatedCheckedResources = [...selectableList];
      }
    },
    handleAdd() {
      if (this.checkedResources.length === 0) {
        return;
      }
      let addList = this.checkedResources
      this.addResources(addList);
      this.checkedResources = [];
    },

    addResources(addList) {
      this.relatedList.push(...addList);
      this.syncRelatedFlag();
    },
    handleDelete() {
      if (this.relatedCheckedResources.length === 0) {
        return;
      }
      let deleteList = this.relatedCheckedResources
      this.deleteResources(deleteList);
      this.relatedCheckedResources = [];
    },

    deleteResources(deleteList) {
      if (!Array.isArray(deleteList) || deleteList.length === 0) {
        return;
      }

      const deleteIds = deleteList.map(item => item.resourceID);

      this.relatedList = this.relatedList.filter(item => {
        return !deleteIds.includes(item.resourceID);
      });
      this.syncRelatedFlag();
    },
    deleteOneResources(item){
      if (!item || !item.resourceID) {
        return;
      }
      let itemList = [item];
      this.deleteResources(itemList);
      this.relatedCheckedResources = this.relatedCheckedResources.filter(
        checked => checked.resourceID !== item.resourceID
      );
    },
    addOneResources(item){
      if (!item || !item.resourceID) {
        return;
      }
      let itemList = [item];
      this.addResources(itemList);

      this.checkedResources = this.checkedResources.filter(
        checked => checked.resourceID !== item.resourceID
      );
    },
    cancel () {
      this.resourceList = [];
      this.relatedList = [];
      this.checkedResources = [];
      this.relatedCheckedResources = [];
      this.query = {
        meetingName: null,
        relatedMeetingName: null
      }
      this.handleDialogClose()
    },
    // Dialog閉じる
    handleDialogClose () {
      this.$emit("update:visible", false)
    },
    OutlookMeetingRoomCreate(){
      let roomInfoList = [];

      if (Array.isArray(this.relatedList) && this.relatedList.length > 0) {
        roomInfoList = this.relatedList.map(item => ({
          roomName: item.resourceName,
          capacity: item.capacity !== undefined ? item.capacity : 0,
          resourceType: '02',
          resourceID: item.resourceID,
          resourceEmail: item.resourceEmail,
          resourceName: item.resourceName
        }));
      } else {
        return;
      }
      // const relatedResourceIdSet = new Set(
      //   this.originalRelatedList.map(item => item.resourceID)
      // )

      // roomInfoList = roomInfoList.filter(
      //   item => !relatedResourceIdSet.has(item.resourceID)
      // )

      let param = {
        areaId: this.areaInfo.areaId,
        roomInfoList
      }

       SystemManageApi.OutlookMeetingRoomCreate(param)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (data.statusCode == "Failure.ErrOwnerAreaAlreadyLentOutMsg") {
            this.$messageIotError(this.$t('message.common.error.ERR_OWNER_AREA_ALREADY_LENT_OUT_MSG'));
            this.showLoading = false
            return;
          }
          if (data.statusCode == "Failure.ErrTenantAreaNotLentOutMsg") {
            this.$messageIotError(this.$t('message.common.error.ERR_TENANT_AREA_NOT_LENT_OUT_MSG'));
            this.showLoading = false
            return;
          }
          if (data.statusCode == "Failure.ErrResourceAlreadyAddedToAnotherFacilityMsg") {
            this.$messageIotError(this.$t('message.common.error.ERR_RESOURCE_ALREADY_ADDED_TO_ANOTHER_FACILITY_MSG'));
            this.showLoading = false
            return;
          }
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.cancel()
          this.$messageIotSuccess(this.$t("message.common.outlookSave"))
          this.$emit('outlook-save');
        }).finally(() => {
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.search-popup {
  ::v-deep  .el-dialog {
    min-width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.flow{
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0%;
  margin: 20px 0 32px;
}

.rightArrow{
  margin: 2px 16px;
}

.viewable-area-style ::v-deep .el-dialog {
  padding-top: 0px !important;
}
.header-style {
  margin-top: 34px;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  color: #525250;
}

.areaInfo{
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 24px;
}
.transfer-box{
  display: flex;
}
.transfer{
  width: 416px;
}
.transfer-header{
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  font-family: Hiragino Kaku Gothic Pro;
  font-weight: 600;
  font-style: W6;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
}
.transfer-search{
  margin: 16px 0;
  ::v-deep.el-input .el-input__inner{
    width: 100%;
  }
}

.transfer-body{
  width: 416px;
  height: 320px;
  background-color: #F7F7F2;
  box-shadow: -3px -3px 4px 0px #FFFFFA inset,
              3px 3px 3px 0px #DEDED1 inset;
  overflow-y: auto;
  padding: 8px 16px 0 16px;
  border-radius: 6px;
}
.transfer-item{
  width: 384px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13.5px 0;
  ::v-deep.el-checkbox__inner{
    border-radius: 4px !important;
    width: 20px!important;
    height: 20px!important;
  }
  ::v-deep.el-checkbox:hover .el-checkbox__inner::before{
    border-radius: 4px !important;
    width: 20px!important;
    height: 20px!important;
  }
  ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner {
    width: 20px !important;
    height: 20px !important;
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMyIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzU5MzdfNTAxOCkiIHN0eWxlPSIiLz4KPHBhdGggZD0iTTUgMTAuNUw4LjUgMTRMMTQuNSA3IiBzdHJva2U9IiNGNUY1RjUiIHN0eWxlPSJzdHJva2U6I0Y1RjVGNjtzdHJva2U6Y29sb3IoZGlzcGxheS1wMyAwLjk2MDggMC45NjA4IDAuOTYwOCk7c3Ryb2tlLW9wYWNpdHk6MTsiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNTkzN181MDE4IiB4MT0iMTAiIHkxPSIwIiB4Mj0iMTAiIHkyPSIyMCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMUM4MzhDIiBzdHlsZT0ic3RvcC1jb2xvcjojMUM4MzhDO3N0b3AtY29sb3I6Y29sb3IoZGlzcGxheS1wMyAwLjEwOTggMC41MTM3IDAuNTQ5MCk7c3RvcC1vcGFjaXR5OjEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNENCNkJGIiBzdHlsZT0ic3RvcC1jb2xvcjojNENCNkJGO3N0b3AtY29sb3I6Y29sb3IoZGlzcGxheS1wMyAwLjI5ODAgMC43MTM3IDAuNzQ5MCk7c3RvcC1vcGFjaXR5OjEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4=);
  }
}
.transfer-button{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 40px;
  margin: 80px 24px 0;
}
.transfer-item .el-checkbox__label{
  padding-left: 16px;
}

.transfer-btn {
  transition: opacity 0.2s;
}

.transfer-add{
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
}

.transfer-btn,
.transfer-btn * {
  cursor: pointer;
}

.disabled {
  opacity: 0.4;
  pointer-events: none;
}

.transfer-btn.disabled {
  opacity: 0.4;
}

.transfer-btn.disabled,
.transfer-btn.disabled * {
  cursor: not-allowed;
}

.noRelated{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Hiragino Kaku Gothic Pro;
  font-weight: 300;
  font-style: W3;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
}

.click-item{
  margin-right: 16px;
}
</style>
